import { assertNever } from 'owa-assert';
import AttachmentDataProviderItem from 'owa-service/lib/contract/AttachmentDataProviderItem';
import AttachmentItemsSortColumn from 'owa-service/lib/contract/AttachmentItemsSortColumn';
import AttachmentItemsSortOrder from 'owa-service/lib/contract/AttachmentItemsSortOrder';

function compareValue(sortType: 'asc' | 'desc', stringA: string, stringB: string): -1 | 0 | 1;
function compareValue(sortType: 'asc' | 'desc', dateA: Date, dateB: Date): -1 | 0 | 1;
function compareValue(
    sortType: 'asc' | 'desc',
    valueA: string | Date,
    valueB: string | Date
): -1 | 0 | 1 {
    let first: string | Date = null;
    let second: string | Date = null;

    switch (sortType) {
        case 'asc':
            [first, second] = [valueA, valueB];
            break;
        case 'desc':
            [first, second] = [valueB, valueA];
            break;
        default:
            assertNever(sortType);
    }

    if (first < second) {
        return -1;
    }

    if (first > second) {
        return 1;
    }

    return 0;
}

export default function sortFileProviderItems(
    items: AttachmentDataProviderItem[],
    sortColumn: AttachmentItemsSortColumn,
    sortOrder: AttachmentItemsSortOrder
): void {
    switch (sortColumn) {
        case AttachmentItemsSortColumn.LastModified:
            items.sort((itemA, itemB) => {
                const modifiedA = itemA.Modified;
                const modifiedB = itemB.Modified;

                const modifiedTimeA = modifiedA ? new Date(modifiedA) : new Date(0);
                const modifiedTimeB = modifiedB ? new Date(modifiedB) : new Date(0);

                const sortType = sortOrder === AttachmentItemsSortOrder.Ascending ? 'asc' : 'desc';
                return compareValue(sortType, modifiedTimeA, modifiedTimeB);
            });
            break;
        case AttachmentItemsSortColumn.Size:
            items.sort((itemA, itemB) => {
                const sizeA = itemA.Size || 0;
                const sizeB = itemB.Size || 0;

                return sortOrder === AttachmentItemsSortOrder.Ascending
                    ? sizeA - sizeB
                    : sizeB - sizeA;
            });
            break;
        default:
            items.sort((itemA, itemB) => {
                const nameA = itemA.Name.toLowerCase();
                const nameB = itemB.Name.toLowerCase();
                const sortType = sortOrder === AttachmentItemsSortOrder.Ascending ? 'asc' : 'desc';

                return compareValue(sortType, nameA, nameB);
            });
    }
}
